module.exports = __webpack_public_path__ + "static/media/json.226b6b74.png";